import { render, staticRenderFns } from "./WebsiteMailboxesPanel.vue?vue&type=template&id=616da9b9&"
import script from "./WebsiteMailboxesPanel.vue?vue&type=script&lang=ts&"
export * from "./WebsiteMailboxesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports